import { Auth } from "@/capacitors/services/AuthService"
import { logInfo } from "@/utils/logger"

/** Refresh token periodically, log warning on failure (expected occasional error, not reported to Sentry) */
export const tokenWorker = async () => {
  try {
    await Auth.Instance.getValidToken(-1800); // buffer > 15min poll interval so a missed tick still refreshes before real expiry
  } catch (error: any) {
    logInfo('Token refresh failed', { error: error?.message });
  }
}
